import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { ApproveDocumentRequest, DeleteDocumentsRequest, GetDocumentsRequest, RejectDocumentRequest, RetryDocumentOcrRequest, UpsertDocumentsRequest } from "./api";

type Props = {
    onSuccess?: (data: any) => void;
    onError?: (error: any) => void;
}

const useUpsertDocument = (tempWorkerId: number, props?: Props) => {
    const queryClient = useQueryClient();
    const {mutate, isLoading, isError, error} = useMutation(UpsertDocumentsRequest, {
        onSuccess: (data: any) => {
            queryClient.invalidateQueries(['temp_workers', `${tempWorkerId}`, 'documents']);
            props?.onSuccess && props.onSuccess(data);
        },
        onError: props?.onError,
    });

    return {mutate, isLoading, isError, error};
};

const useDeleteDocument = (tempWorkerId: number, props?: Props) => {
    const queryClient = useQueryClient();
    const {mutate, isLoading, isError, error} = useMutation(DeleteDocumentsRequest, {
        onSuccess: (data: any) => {
            queryClient.invalidateQueries(['temp_workers', `${tempWorkerId}`, 'documents']);
            props?.onSuccess && props.onSuccess(data);
        },
        onError: props?.onError,
    });

    return {mutate, isLoading, isError, error};
};

const useGetDocuments = (tempWorkerId: number, props?: Props) => {
    const {data, isLoading, isError} = useQuery<any>(['temp_workers', `${tempWorkerId}`, 'documents'], () => GetDocumentsRequest(tempWorkerId), {
        onSuccess: props?.onSuccess,
        onError: props?.onError,
    });

    return {data, isLoading, isError};
};

const useApproveDocument = (tempWorkerId: number, props?: Props) => {
  const queryClient = useQueryClient();

  return useMutation(ApproveDocumentRequest, {
    onSuccess: (data: any) => {
      if (data?.temp_worker) {
        queryClient.setQueryData(['temp_workers', `${tempWorkerId}`], data.temp_worker);
      }
      queryClient.invalidateQueries(['temp_workers', `${tempWorkerId}`]);
      queryClient.invalidateQueries(['temp_workers', `${tempWorkerId}`, 'documents']);
      props?.onSuccess && props.onSuccess(data);
    },
    onError: props?.onError,
  });
};

const useRejectDocument = (tempWorkerId: number, props?: Props) => {
  const queryClient = useQueryClient();

  return useMutation(RejectDocumentRequest, {
    onSuccess: (data: any) => {
      queryClient.invalidateQueries(['temp_workers', `${tempWorkerId}`, 'documents']);
      props?.onSuccess && props.onSuccess(data);
    },
    onError: props?.onError,
  });

};

const useRetryDocumentOcr = (tempWorkerId: number, props?: Props) => {
  const queryClient = useQueryClient();

  return useMutation(RetryDocumentOcrRequest, {
    onSuccess: (data: any) => {
      queryClient.invalidateQueries(['temp_workers', `${tempWorkerId}`, 'documents']);
      props?.onSuccess && props.onSuccess(data);
    },
    onError: props?.onError,
  });
};

export { useUpsertDocument, useDeleteDocument, useGetDocuments, useApproveDocument, useRejectDocument, useRetryDocumentOcr };
